/**
 * UnitsBreakdown Component
 *
 * The card's right-hand units column — "6 new +1 swp / 2 used +1 whl = 9".
 * Shared by member rows and team subtotal rows so the two line up exactly and
 * apply the same swap/wholesale suppression rules.
 */

import React from 'react';
import { formatUnits } from './format';

interface UnitsBreakdownProps {
  newUnits: number;
  swapUnits: number;
  usedUnits: number;
  wholesaleUnits: number;
  totalUnits: number;
  /** Subtotal rows read heavier than member rows. */
  emphasis?: boolean;
}

export const UnitsBreakdown: React.FC<UnitsBreakdownProps> = ({
  newUnits,
  swapUnits,
  usedUnits,
  wholesaleUnits,
  totalUnits,
  emphasis = false,
}) => (
  <div className={`text-right text-sm w-52 ${emphasis ? 'font-medium' : ''}`}>
    <span className="text-blue-700 font-medium">{formatUnits(newUnits)}</span>
    <span className="text-gray-400"> new</span>
    {swapUnits > 0 && (
      <>
        <span className="text-blue-400"> +{formatUnits(swapUnits)}</span>
        <span className="text-gray-400"> swp</span>
      </>
    )}
    <span className="text-gray-400"> / </span>
    <span className="text-gray-700 font-medium">{formatUnits(usedUnits)}</span>
    <span className="text-gray-400"> used</span>
    {wholesaleUnits > 0 && (
      <>
        <span className="text-purple-500"> +{formatUnits(wholesaleUnits)}</span>
        <span className="text-gray-400"> whl</span>
      </>
    )}
    <span className="text-gray-400"> = </span>
    <span className="text-gray-900 font-semibold">{formatUnits(totalUnits)}</span>
  </div>
);
